const storySettings = [
  '故事地基打好了，继续写下去才能解锁一键投稿📬',
  '写得这么带感，别停！结尾等你来投稿🔥',
  '世界观已立，主角等你赋予命运，写完快来投稿！',
  '老板你设定太牛了！继续写完就能一键投稿💥',
  '设定都写完了？前方有惊喜，但要先写完哦✍️',
  '大世界已搭好，想投稿还得继续写完剧情～',
  '咱就是说，写完再投稿，流程闭环懂？😉',
  '一步步推进，等你最终一键投稿文章大爆！💡',
  '你离投稿就差坚持到最后一步啦💪',
  '设定有了，旅程才刚开始，结局才有投稿等着你～🚀'
]
const storySettingsEn = [
  "The foundation of your story is set! Keep writing to unlock one-click submission.📬",
  "It's getting exciting, don't stop! The ending is waiting for your submission.🔥",
  "The world is built, the protagonist awaits their fate—finish and submit your story!",
  "Boss, your settings are awesome! Finish writing to unlock one-click submission.💥",
  "All settings done? Surprises ahead, but you need to finish first.✍️",
  "The big world is ready, but you need to finish the plot to submit!",
  "Finish writing before submitting—complete the loop, you know?😉",
  "Step by step, keep going until your story explodes with a one-click submission!💡",
  "You're just one step away from submitting—keep it up!💪",
  "Settings are done, the journey has just begun. The ending and submission await you!🚀"
]

const storyElements = [
  '情节、冲突、人设都立住了！继续写完就能投稿啦📚',
  '角色安排得明明白白，再写几章，投稿稳了！',
  'cp有了？那就走完流程，一键投稿就差你！',
  '写下去，闯过剧情大关，最后解锁一键投稿通道！',
  '冲突已经拉满！投稿按钮在终点等你来敲门～🔔',
  '情节有看头，再来点实打实的正文，直接上交编辑部！',
  '趁思路清晰，一鼓作气冲到投稿终点！🔥',
  '人设那么绝，剧情不写完不投稿也太可惜了吧？',
  '太棒了！快冲完剩下的剧情，一键投稿才能安排！',
  '继续写，别断电～写到最后就能点投稿了✨'
]
const storyElementsEn = [
  "Plot, conflict, and characters are all set! Finish writing to submit your story.📚",
  "Characters are perfectly arranged. Write a few more chapters and submission is guaranteed!",
  "Got your CP? Complete the process—one-click submission is waiting for you!",
  "Keep writing, overcome the plot hurdles, and unlock the submission channel at the end!",
  "Conflicts are maxed out! The submit button is waiting for you at the finish line.🔔",
  "The plot is engaging—add some solid content and send it straight to the editors!",
  "While your ideas are clear, push through to the submission finish line!🔥",
  "With such great characters, it would be a shame not to finish and submit the story!",
  "Awesome! Rush through the remaining plot to enable one-click submission!",
  "Keep writing, don't lose power—finish to unlock the submission button!✨"
]

const storyOutline = [
  '主线已定，离投稿的舞台只差一口气了！💨',
  '写完大纲别走！还有正文要搞定才可以投稿哦～',
  '有大纲不迷路，写完就是投稿赚钱了！',
  '编辑爱有节奏的作品！写完再投稿更香～',
  '大纲是起点，章纲才是敲开投稿门的钥匙🗝️',
  '结构在线，下一站→写章纲→投稿通道开启✨',
  '不把大纲变成实打实的内容，投稿按钮可不认你哦～😆',
  '快冲！后面几步坚持住才能打开“一键投稿”🏅',
  '一鼓作气写下去，等你解锁投稿大门！🎉',
  '这波计划已经天衣无缝，就差你写完按投稿啦！'
]
const storyOutlineEn = [
  "The main plot is set—you're just a breath away from the submission stage!💨",
  "Don't leave after finishing the outline! You need to complete the main text to submit.",
  "With an outline, you won't get lost. Finish writing and start earning from submissions!",
  "Editors love well-paced works! Finish writing before submitting for the best effect.",
  "The outline is the start, but chapter outlines are the key to submission.🗝️",
  "Structure is on point. Next stop: chapter outlines, then the submission channel opens!✨",
  "If you don't turn the outline into real content, the submit button won't recognize you!😆",
  "Push through! Only a few more steps to unlock one-click submission.🏅",
  "Keep going in one go—unlock the submission gate at the end!🎉",
  "This plan is flawless—just finish and hit submit!"
]

const storyChapter = [
  '章纲写这么细，写完之后直接投稿不香嘛？🌸',
  '全文安排得明明白白，剩下就是执行+投稿啦！',
  '写到这了，别掉链子！投稿按钮已在终点闪闪发光✨',
  '继续写完，才能收获一键投稿的快乐果实🍎',
  '写得这么稳了，差个正文就能毕业去投稿！🎓',
  '投稿这扇门，只向完成创作的人敞开哦～🚪',
  '每写一章，离投稿就更近一步！冲鸭！🏃‍♀️',
  '不差了不差了，再码一点点就能投稿啦！📬',
  '节奏安排太棒了！继续完成后编辑必爱！💘',
  '离投稿只差最后一程，别断电，坚持住！'
]
const storyChapterEn = [
  "Your chapter outline is so detailed—won't it feel great to submit after finishing?🌸",
  "The whole story is well planned. All that's left is to execute and submit!",
  "You've come this far, don't drop the ball! The submit button is shining at the finish line.✨",
  "Finish writing to enjoy the sweet fruit of one-click submission!🍎",
  "You're so steady—just the main text left before you can graduate and submit!🎓",
  "The door to submission only opens for those who finish their work.🚪",
  "Every chapter you write brings you closer to submission. Go for it!🏃‍♀️",
  "Almost there, just a bit more and you can submit!📬",
  "Your pacing is perfect! Editors will love it once you finish!💘",
  "Only the final stretch left before submission—don't lose power, keep going!"
]

const storyContent = [
  ' 恭喜你！创作全程走完啦！点击投稿冲一波🔥',
  '📢 写完啦写完啦！快把你的大作投出去收割掌声吧👏',
  '📝 你都肝到这步了，点下投稿就能一飞冲天啦！🚀',
  '🐮 文已杀青，快投稿上桌！让编辑一口吞下你的才华！',
  '🎁 这是你为梦想写下的结局，也是投稿打开的起点！',
  '🧨 爆点剧情写完了？那就该是投稿爆火的时候了🔥',
  '🫡 写都写完了不投稿？不合理！点一下冲个榜！',
  '🐣 作品孵化完成，下一步→飞向读者的怀抱投稿去！',
  '😎 你已经准备就绪了，点一下投稿，开启主角剧本！',
  '🍰 全文出炉，热气腾腾，快投稿端给平台试试味！'
]
const storyContentEn = [
  "Congratulations! You've completed your creation—click submit and go for it!🔥",
  "All done! Submit your masterpiece and reap the applause!👏",
  "You've made it this far—one click to submit and soar to the top!🚀",
  "Your work is finished—submit it and let the editors savor your talent!🐮",
  "This is the ending you wrote for your dream, and the beginning of your submission journey!🎁",
  "Finished the explosive plot? Now's the time to submit and go viral!🔥",
  "You've written it all—why not submit? Click and hit the charts!🫡",
  "Your work is hatched—next step: fly to your readers with a submission!🐣",
  "You're ready—click submit and start your protagonist's journey!😎",
  "The whole story is out, fresh and hot—submit it to the platform for a taste!🍰"
]


const submission = [
  '📨 写完啦！点我一键投稿，让编辑第一时间看到你！',
  '你的故事值得被更多人看见！点我投稿试试？',
  '🎉 恭喜完稿！来点一下投稿，冲向签约舞台！',
  '💥 爆文潜力拉满！点击投稿，梦想从这里出发～',
  '👀 不点一下投稿，你永远不知道能不能火！',
  '🛎️ 作品已就绪，敲响编辑的门铃就差这一键啦～',
  '✨ 机会在这，手指点一下，也许就被签走了！',
  '🔥 今日运势+999！投稿一下，说不定爆了！',
  '🐣 你的故事孵化完成，点我投稿让它飞出去吧～',
  '🧨 写都写完了，别藏着啦，点我投稿炸场子！'
]
const submissionEn = [
  "All done! Click to submit and let the editors see your work first!📨",
  "Your story deserves a bigger audience! Try submitting it?",
  "Congrats on finishing! Click submit and head for the signing stage!🎉",
  "Your story is full of potential! Click submit—let your dreams start here!💥",
  "You'll never know if you'll go viral unless you submit!👀",
  "Your work is ready—just one click to ring the editor's bell!🛎️",
  "Here's your chance—one click and you might get signed!✨",
  "Today's luck +999! Submit now, maybe you'll go viral!🔥",
  "Your story is hatched—click submit and let it fly!🐣",
  "You've finished writing—don't hide it, submit and rock the stage!🧨"
]


function sample(array) {
  return array[Math.floor(Math.random() * array.length)]
} 

export function getTips(type, lang = 'zh') {
  if (type === 'storySettings') {
    return sample(lang === 'en' ? storySettingsEn : storySettings)
  } else if (type === 'storyElements') {
    return sample(lang === 'en' ? storyElementsEn : storyElements)
  } else if (type === 'storyOutline') {
    return sample(lang === 'en' ? storyOutlineEn : storyOutline)
  } else if (type === 'storyChapter') {
    return sample(lang === 'en' ? storyChapterEn : storyChapter)
  } else if (type === 'storyContent') {
    return sample(lang === 'en' ? storyContentEn : storyContent)
  } else if (type === 'submission') {
    return sample(lang === 'en' ? submissionEn : submission)
  } else {
    return ''
  }
}
